'use client'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useExploreTeams } from '../hooks/useFootball'
import { useT } from '../contexts/LocaleContext'
import { format } from 'date-fns'

export default function FantasyExplorePage() {
  const navigate = useNavigate()
  const t = useT()
  const [input, setInput] = useState('')
  const [query, setQuery] = useState('')

  const { data, isLoading, isFetching, error } = useExploreTeams(query)

  useEffect(() => {
    const timer = setTimeout(() => setQuery(input.trim()), 350)
    return () => clearTimeout(timer)
  }, [input])

  const teams = data?.teams || []

  return (
    <div className="lucky-fb mini-app-container pb-20 min-h-screen">
      <div className="lucky-fb__inner">
        <header className="lucky-fb__header">
          <button type="button" className="lucky-wallet__back" onClick={() => navigate('/football')} aria-label={t('common.back')}>
            →
          </button>
          <div>
            <h1>{t('dreamTeam.titlePlural')}</h1>
            <p>
              {isFetching && !isLoading
                ? t('fantasy.explore.subtitleRefreshing')
                : t('fantasy.explore.subtitleDefault')}
            </p>
          </div>
        </header>

        <section className="lucky-fb__card">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={t('fantasy.explore.searchPlaceholder')}
            className="lucky-wallet__input"
          />
          {query && (
            <p className="lucky-fb__hint" style={{ marginTop: 10, marginBottom: 0 }}>
              {t('fantasy.explore.resultsFor', { query })}
            </p>
          )}
        </section>

        {error ? (
          <div className="lucky-fb__card lucky-fb__empty">{t('fantasy.explore.loadError')}</div>
        ) : isLoading ? (
          <div className="lucky-fb__empty">{t('common.loading')}</div>
        ) : teams.length === 0 ? (
          <div className="lucky-fb__card lucky-fb__empty">
            {query ? t('fantasy.explore.emptySearch') : t('fantasy.explore.emptyDefault')}
          </div>
        ) : (
          <div className="lucky-side__grid">
            {teams.map((team) => {
              const startTime = team.start_time ? new Date(team.start_time) : null
              return (
                <button
                  key={team.id}
                  type="button"
                  className="lucky-side__tile"
                  onClick={() => navigate(`/fantasy/vote?token=${team.share_token}`)}
                >
                  <strong>{team.name}</strong>
                  <span>{team.formation}</span>
                  {team.owner_name && (
                    <span className="is-muted">{t('dreamTeam.view.creator', { name: team.owner_name })}</span>
                  )}
                  {team.home_team && (
                    <span className="is-muted">
                      {team.home_team} - {team.away_team}
                    </span>
                  )}
                  {startTime && (
                    <span className="is-muted">{format(startTime, 'yyyy/MM/dd HH:mm')}</span>
                  )}
                  <div className="lucky-side__tile-foot">
                    <em>
                      ★ {team.avg_rating ? team.avg_rating.toFixed(1) : '—'} ({team.vote_count})
                    </em>
                    <i className={team.voting_open ? 'is-open' : ''}>
                      {team.voting_open ? t('dreamTeam.voting.votingOpen') : t('dreamTeam.voting.votingClosed')}
                    </i>
                  </div>
                </button>
              )
            })}
          </div>
        )}

        <button type="button" className="lucky-fb__cta" style={{ marginTop: 12 }} onClick={() => navigate('/football')}>
          {t('fantasy.explore.backToMatches')}
        </button>
      </div>
    </div>
  )
}
